import { isEmpty } from 'src/utils'
import { idhBrandId, phnxSiteIDv2 } from 'src/constants'

const DeviceIdParser = () => {
  return {
    /**
     * Build payload for Device to Token endpoint
     */
    async parseDeviceToTokenPayload() {
      const rvid = JSON.parse(localStorage.getItem('rvid'))
      if (isEmpty(rvid)) throw new Error('No rvid on localStorage')
      const { relevantId = {} } = rvid
      const [languageCode] = navigator.language.split('-')
      const interactionId = ''

      return {
        deviceId: relevantId,
        idhBrandId: parseInt(idhBrandId),
        siteId: parseInt(phnxSiteIDv2),
        languageCode: languageCode || 'en',
        interactionId
      }
    }
  }
}

export default DeviceIdParser
